export default "__VITE_ASSET__eyq7jEgz__"